export const APRS_WEBAPP_SOVI_AI_ENABLED = false;

export const STAGING_TRANSLATION_OPERATORS = [
    { value: "eq", label: "=", hasFindValue: true, findValueShape: "string" },
    { value: "neq", label: "!=", hasFindValue: true, findValueShape: "string" },
    { value: "contains", label: "contains", hasFindValue: true, findValueShape: "string" },
    { value: "starts_with", label: "starts with", hasFindValue: true, findValueShape: "string" },
    { value: "ends_with", label: "ends with", hasFindValue: true, findValueShape: "string" },
    { value: "is_null", label: "is null", hasFindValue: false, findValueShape: "none" },
    { value: "is_not_null", label: "is not null", hasFindValue: false, findValueShape: "none" },
    { value: "in", label: "in", hasFindValue: true, findValueShape: "array" },
];

export const operatorMeta = (operator) =>
    STAGING_TRANSLATION_OPERATORS.find((op) => op.value === operator) || null;

export const formatConditionSummary = (translation) => {
    if (!translation) return "";
    const meta = operatorMeta(translation.operator);
    const col = translation.column_name;
    if (!meta) return `${col} ${translation.operator} ${translation.find_value ?? ""}`;
    switch (translation.operator) {
        case "is_null":
            return `${col} is null`;
        case "is_not_null":
            return `${col} is not null`;
        case "in": {
            let values = [];
            try { values = JSON.parse(translation.find_value || "[]"); } catch { values = []; }
            const preview = values.slice(0, 3).map((v) => `"${v}"`).join(", ");
            const extra = values.length > 3 ? `, +${values.length - 3} more` : "";
            return `${col} in (${preview}${extra})`;
        }
        default:
            return `${col} ${meta.label} "${translation.find_value ?? ""}"`;
    }
};
